import { createContext, useContext } from "react";

/**
 * Opt-in accessible wording for required form fields.
 *
 * WCAG says not to rely on color alone, and an asterisk by itself is a cue
 * that lower-vision users and machine translation can miss. When a subtree
 * provides a non-null word here (the enrollment form supplies the active
 * locale's "required"), `FieldLabel`, `Checkbox` and `RadioGroup` render a
 * visible "(required)" suffix after the label text in addition to the
 * asterisk. The default, `null`, renders the asterisk only.
 */
export const RequiredIndicatorContext = createContext<string | null>(null);

/** The localized required-word for the current subtree, or `null` when the
 *  subtree hasn't opted in (asterisk-only rendering). */
export function useRequiredIndicator(): string | null {
  return useContext(RequiredIndicatorContext);
}
